const EntityFormModalHeadTestIdsScope = {
  ENTITY_FORM_MODAL_HEAD: 'entity-form-modal-head',
};

export const EntityFormModalHeadTestIds = {
  CLOSE_BUTTON: `${EntityFormModalHeadTestIdsScope.ENTITY_FORM_MODAL_HEAD}.close-button`,
};
